const setup = () => {
  window.__RUNTIME_CONFIG__ = {
    ...process.env,
    ...window.__RUNTIME_CONFIG__
  }
}

export default setup;